import React, { Component } from 'react'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import { getLoggedInUser } from '../api.js'
const styles = theme => ({
  root: {
    textTransform: 'uppercase',
    padding: 20,
    color: 'silver'
  },
  logoutButton: {
    textDecoration: 'underline',
    display: 'inline',
    cursor: 'pointer',
    color: 'silver'
  }
})

class LogoutButton extends Component {
  constructor (props) {
    super(props)

    this.state = {
      username: null
    }
  }

  componentDidMount () {
    getLoggedInUser().then(response => this.setState({username: response.username}))
  }

  render () {
    const { classes } = this.props
    const { username } = this.state

    if (process.env.REACT_APP_HOST == 'NETLIFY') {
      return (
        <div className={classes.root} style={Object.assign({}, styles)}>
          Welcome, {username} | <a href='https://webapp.dev.alacrityps.com/logout' className={classes.logoutButton}> LOG OUT</a>
        </div>
      )
    } else {
      return (
        <div className={classes.root} style={Object.assign({}, styles)}>
          Welcome, {username} | <a href='/logout' className={classes.logoutButton}> LOG OUT</a>
        </div>
      )
    }
  }
}

export default withStyles(styles)(LogoutButton)



// WEBPACK FOOTER //
// ./src/components/LogoutButton.js